module.exports = __webpack_public_path__ + "media/app/assets/imgs/events/privacy-secret-7ffbd029776da94169a7d9667968341c.png";